// extracted by mini-css-extract-plugin
module.exports = {"RoundedButton":"RoundedButton_RoundedButton__czqee","fullWidth":"RoundedButton_fullWidth__SNa3g"};